var _defs, _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBilling = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55.05 58.92",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Asset 8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,46.19a24.89,24.89,0,0,1-12.15-2.9c-3.42-2-5.3-4.64-5.3-7.53s1.88-5.56,5.3-7.53c6.7-3.86,17.6-3.86,24.3,0,3.41,2,5.3,4.65,5.3,7.53s-1.89,5.56-5.3,7.53A24.89,24.89,0,0,1,37.6,46.19Zm0-19.06a23,23,0,0,0-11.24,2.68C23.53,31.44,22,33.56,22,35.76s1.56,4.33,4.39,6c6.2,3.57,16.28,3.57,22.48,0,2.83-1.63,4.39-3.75,4.39-6s-1.56-4.32-4.39-5.95h0A23,23,0,0,0,37.6,27.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,52.56a24.89,24.89,0,0,1-12.15-2.9c-3.53-2-5.41-4.8-5.29-7.78A.91.91,0,1,1,22,42c-.08,2.28,1.47,4.45,4.39,6.14,6.2,3.57,16.28,3.57,22.48,0,2.83-1.64,4.39-3.75,4.39-6a.91.91,0,0,1,1.82,0c0,2.88-1.89,5.56-5.3,7.53A24.89,24.89,0,0,1,37.6,52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.06,43.15a.91.91,0,0,1-.91-.91V35.88a.91.91,0,0,1,1.82,0v6.36A.91.91,0,0,1,21.06,43.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.14,43.15a.91.91,0,0,1-.91-.91V35.88a.91.91,0,0,1,1.82,0v6.36A.91.91,0,0,1,54.14,43.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,58.92A24.89,24.89,0,0,1,25.45,56c-3.53-2-5.41-4.79-5.29-7.77a.91.91,0,0,1,1.81.07c-.08,2.27,1.47,4.45,4.39,6.13,6.2,3.57,16.28,3.57,22.48,0,2.83-1.63,4.39-3.75,4.39-6a.91.91,0,0,1,1.82,0c0,2.89-1.89,5.56-5.3,7.53A24.89,24.89,0,0,1,37.6,58.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.06,49.51a.91.91,0,0,1-.91-.91V42.24a.91.91,0,0,1,1.82,0V48.6A.91.91,0,0,1,21.06,49.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.14,49.51a.91.91,0,0,1-.91-.91V42.24a.91.91,0,0,1,1.82,0V48.6A.91.91,0,0,1,54.14,49.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.45,20.85A24.89,24.89,0,0,1,5.3,18C1.88,16,0,13.31,0,10.43S1.88,4.87,5.3,2.9C12-1,22.9-1,29.6,2.9c3.41,2,5.29,4.64,5.29,7.53S33,16,29.6,18A24.89,24.89,0,0,1,17.45,20.85Zm0-19.06A23,23,0,0,0,6.21,4.47c-2.83,1.63-4.39,3.75-4.39,6s1.56,4.32,4.39,5.95C12.4,20,22.49,20,28.69,16.38c2.83-1.63,4.39-3.74,4.39-5.95s-1.56-4.33-4.39-6h0A23,23,0,0,0,17.45,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.45,27.22A24.89,24.89,0,0,1,5.3,24.32c-3.53-2-5.41-4.79-5.3-7.77a.91.91,0,1,1,1.82.07c-.09,2.27,1.47,4.45,4.39,6.13,6.19,3.57,16.28,3.57,22.48,0,2.83-1.63,4.39-3.75,4.39-6a.91.91,0,1,1,1.81,0c0,2.89-1.88,5.56-5.29,7.53A24.89,24.89,0,0,1,17.45,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.91,17.81A.91.91,0,0,1,0,16.9V10.54a.91.91,0,0,1,1.82,0V16.9A.91.91,0,0,1,.91,17.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,17.81a.91.91,0,0,1-.91-.91V10.54a.91.91,0,1,1,1.81,0V16.9A.9.9,0,0,1,34,17.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.47,33.6A25,25,0,0,1,5.3,30.69c-3.53-2-5.41-4.8-5.3-7.78A.91.91,0,0,1,1,22a.91.91,0,0,1,.87.94c-.09,2.27,1.47,4.45,4.39,6.13,4.06,2.35,10.06,3.24,15.64,2.32a.91.91,0,1,1,.29,1.79A29.22,29.22,0,0,1,17.47,33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.85,27.54a.9.9,0,0,1-.51-.16.91.91,0,0,1-.24-1.26,5.23,5.23,0,0,0,1-3,.91.91,0,1,1,1.81,0,7,7,0,0,1-1.28,4A.93.93,0,0,1,32.85,27.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.91,24.18A.91.91,0,0,1,0,23.27V16.9a.91.91,0,0,1,1.82,0v6.37A.91.91,0,0,1,.91,24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,24.18a.91.91,0,0,1-.91-.91V16.9a.91.91,0,1,1,1.81,0v6.37A.9.9,0,0,1,34,24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.43,39.44A24.79,24.79,0,0,1,5.3,36.52c-3.53-2-5.41-4.8-5.3-7.78a.92.92,0,0,1,1-.87.91.91,0,0,1,.87.94C1.73,31.09,3.29,33.27,6.21,35c3.85,2.22,9.36,3.14,14.74,2.45a.89.89,0,0,1,1,.78.91.91,0,0,1-.78,1A29.62,29.62,0,0,1,17.43,39.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.91,30A.91.91,0,0,1,0,29.1V22.74a.91.91,0,1,1,1.82,0V29.1A.91.91,0,0,1,.91,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,27.37a.91.91,0,0,1-.91-.91V22.74a.91.91,0,1,1,1.81,0v3.72A.9.9,0,0,1,34,27.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.43,45.27A24.68,24.68,0,0,1,5.3,42.35c-3.53-2-5.41-4.79-5.3-7.77a.91.91,0,0,1,1-.87.9.9,0,0,1,.87.94c-.09,2.27,1.47,4.45,4.39,6.13C10.06,43,15.57,43.92,21,43.23a.91.91,0,0,1,.23,1.8A29.62,29.62,0,0,1,17.43,45.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.91,35.84a.9.9,0,0,1-.91-.9V28.57a.91.91,0,0,1,1.82,0v6.37A.9.9,0,0,1,.91,35.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.43,51.1A24.79,24.79,0,0,1,5.3,48.19c-3.53-2-5.41-4.8-5.3-7.78a.91.91,0,0,1,1-.87.91.91,0,0,1,.87.94c-.09,2.28,1.47,4.45,4.39,6.13,3.85,2.23,9.36,3.14,14.74,2.45a.91.91,0,0,1,.23,1.81A29.61,29.61,0,0,1,17.43,51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.91,41.68A.91.91,0,0,1,0,40.77V34.41a.91.91,0,0,1,1.82,0v6.36A.91.91,0,0,1,.91,41.68Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBilling, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/billing.eee4e93e.svg";
export { ForwardRef as ReactComponent };